import { Block } from 'baseui/block';
import { ISP_OutsideConditions } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { ValuePanelIcon } from '../../Devices/SensorAnalog'
import { LoadingView } from "../../../components";
import { RiSunFoggyLine } from 'react-icons/ri'
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { useMemo } from 'react';
import { themedUseStyletron } from '../../../theme/customTheme';
import { HorizontalStackPanel, VerticalStackPanel } from '../../../components/Layout/StackPanel';

export function OverviewPanel(props: ISP_OutsideConditions) {
    const [, theme] = themedUseStyletron();
    const { children: childElements, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)

    const sensors = useMemo(() => childElements?.filter((v: any) => v.schema === "AutomationApps.Devices.Sensors.SensorAnalog"), [childElements]);
    const temperature = useMemo(() => childElements?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.TemperatureSensor"), [childElements]);
    const humidity = useMemo(() => childElements?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.HumiditySensor"), [childElements]);
    const pressure = useMemo(() => childElements?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.PressureSensor"), [childElements]);


    return (
        <OverviewPanelWrapper includeAlarmsFromChildren height={theme.appSizes.smallAppHeight} icon={<RiSunFoggyLine size='100%' color={theme.colors.backgroundPrimary}></RiSunFoggyLine>} {...props}>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <VerticalStackPanel $alignItems={'center'}>
                    <HorizontalStackPanel>
                        {temperature && <ValuePanelIcon {...temperature}></ValuePanelIcon>}
                        {humidity && <ValuePanelIcon {...humidity}></ValuePanelIcon>}
                    </HorizontalStackPanel>
                    <HorizontalStackPanel $gap={theme.sizing.scale400}>
                        {pressure && <ValuePanelIcon small {...pressure}></ValuePanelIcon>}
                        {sensors?.map((v) => (<ValuePanelIcon small key={v.id} {...v}></ValuePanelIcon>))}
                    </HorizontalStackPanel>
                </VerticalStackPanel>
            </LoadingView>
        </OverviewPanelWrapper>
    );
}